import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import { toFixed2, toNumber } from "../components/exportUtils";

const stockText = (row) => (parseInt(row?.track_stock) === 1 ? String(parseInt(row?.stock_qty) || 0) : "Not tracked");

const columns = [
    { key: "title", label: "Item", primary: true },
    { key: "sku", label: "SKU", render: (row) => row?.sku || "-", exportValue: (row) => row?.sku || "" },
    { key: "stock_qty", label: "In Stock", align: "right", render: stockText, exportValue: stockText },
    { key: "restocked", label: "Restocked", align: "right" },
    { key: "sold", label: "Sold", align: "right" },
    { key: "returned", label: "Returned", align: "right" },
    { key: "adjusted", label: "Adjusted", align: "right" },
    { key: "stock_value", label: "Stock Value", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.stock_value)), exportValue: (row) => toFixed2(row?.stock_value) },
];

// Stock in and out over the selected dates (all time without a date range), with current stock
const ShopInventoryReport = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Shop Inventory Report", websiteData);

    const report = useServerReport("report/shop-inventory");

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Shop Inventory Report" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Shop Inventory Report" filename="shop-inventory-report" searchPlaceholder="Search by item" />
            <ReportTable report={report} columns={columns} />
        </div>
    </div>);
};

export default withAdminAuth(ShopInventoryReport);
